import { ApplicationRef, ChangeDetectorRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollingService {
  constructor(private ref: ApplicationRef) { }

  detectChangesAndScrollSmoothlyTo(elementId: string): void {
    this.ref.tick();
    const element: HTMLElement = document.getElementById(elementId);
    element.scrollIntoView({ behavior: 'smooth' });
  }
}
